import React, {
  useEffect,
  useState,
  useRef,
  useContext,
  useLayoutEffect,
} from "react";
import Toolbar from "./assetsToolBar";
import FurtherSetting from "./furtherSetting";
import "react-image-crop/dist/ReactCrop.css";
// import { SelectableGroup } from 'react-selectable-fast';
import MyContext from "../../context/MyContext";
import SoundPlay from "./SoundPlay";
import ProjectContext from "../../context/ProjectContext";
import TickerContext from "../../context/ticker";
//import "animate.css";
import TrackerImages from "./TrackerSubComponent/TrackerImages";
import TrackerVideo from "./TrackerSubComponent/TrackerVideo";
import TrackerText from "./TrackerSubComponent/TrackerText";
import ChangeableShapes from "./TrackerSubComponent/ChangeableShapes";
import AuthContext from "../../context/userAuth.context";
import TrackerShapes from "./TrackerSubComponent/TrackerShapes";
import TrackerProps from "./TrackerSubComponent/TrackerProps";
import TrackerCharacter from "./TrackerSubComponent/TrackerCharacter";
import MotionOverlay from "./MotionOverlay";
import CanvasContextMenu from "./CanvasContextMenu";
import AudioDucker from "./AudioDucker";
import CanvasOverlay from "./CanvasOverlay";
import MyResize from "./myResize";
import MultiDragging from "./MultiDrag/MultiDragging";
import LockBar from "./lockBar";
import Loading from "../../Loaders/Loading";
import { LoadingContext } from "../../context/LoadingContext";
import Lottie from "react-lottie-player";
import { getJSON } from "../../Utils/Common";
import TTSSettings from "../../TextToSpeech/TTSSettings";
import Lottie2 from "lottie-web";
import AnimatedText from "./Texts/AnimatedText";
import AssetsWrapper from "../leftmenu.component/SUBcomponents/Assets/assetsWrapper";

export const EditorTracker = (props) => {
  const context = useContext(LoadingContext);
  const { TickerPosition, TickerStart } = useContext(TickerContext);

  const { slides, setslides, CurrentProject, setLayersData } =
    useContext(ProjectContext);

  const {
    CanvasDisplay,
    LayersData,
    clone,
    setRedoLayer,
    UndoLayer,
    setUndoLayer,
    Backgrounds,
    EditorZoom,
    calculateWidthByDuration,
    msToTimeMini,
    onePxEquivalent,
    setTl_TotalTime,
    setBackgrounds,
    Tl_TotalTime,
    setPrevious_TlTotalTime,
    isPlayClicked,
    IsTTSShow,
    setIsTTSShow,
    TTSData,
    setTTSData,
    SoundRef,
    changeTimelineZoomVal,
    timelineZoomVal,
    editableObject,
    isTTS,
    setIsTTS,
    seteditableObject,
    setisTextInputOrAreaFocus,
    setAciveShapeColor,
    AciveShapeColor,
    Call_ScreenShot,
    setCall_ScreenShot,
    setenableGrid,
    enableGrid,
    setenableRuler,
    enableRuler,
    Call_CurrentProject,
    setCall_CurrentProject,
    setMultiDrag,
    MultiDrag,
  } = useContext(MyContext);

  const { authenticationData } = useContext(AuthContext);

  const EditorParent = useRef(null);

  const EditorTrackerStart = useRef(null);

  const EditorTrackInner = useRef(null);

  const [EditorStyle, setEditorStyle] = useState(null);

  const [MainDiv, setMainDiv] = useState(null);

  const inputRef = useRef(null);

  const [colorShow, setcolorShow] = useState(false);

  const [StrokeShow, setStrokeShow] = useState(false);

  const [FontShow, setFontShow] = useState(false);

  const [SliderShow, setSliderShow] = useState(false);

  const [overlayHide, setoverlayHide] = useState(false);

  const [overlaydiv, setoverlaydiv] = useState(false);

  const [Styled, setStyle] = useState(null);

  const [AtoZ, setAtoZ] = useState([]);

  const resizeRef = useRef(null);

  const resizeRef2 = useRef(null);

  const DraggerRef = useRef(null);



  const [DragProcess, setDragProcess] = useState(false);

  const [AnimatedBGData, setAnimatedBGData] = useState(null);
  const [isStanding, setIsStanding] = useState(false);
  const [hiddenSide1, sethiddenSide1] = useState({});
  const [hiddenSideLeft, sethiddenSideLeft] = useState({});

  // const [isTTS, setIsTTS] = useState(false);

  // useEffect(() => {
  //     if (LayersData.length == 0)
  //         return;

  //     LayersData.forEach(item => {
  //         if (item.type !== "Character") {
  //             return;
  //         }
  //         else if (item.type === "Character" && item.JSONValue === undefined) {
  //             (async () => {
  //                 const resp = await fetch(authenticationData.ApiBaseURL + "/" + item.character_FilePath);
  //                 const jsonData = await resp.json();
  //                 item.JSONValue = jsonData;
  //             })();
  //         }
  //     })
  // }, [LayersData]);


 

  useEffect(() => {
    if (CurrentProject.canvasSize == "16:9") {
      let mainHeight = EditorParent.current.offsetHeight - 20;
      let Mainwidth = EditorParent.current.offsetWidth;
      let cal = mainHeight * 1.77778;
      let Margin = 10;
      if (cal > Mainwidth) {
        cal = (Mainwidth * 80) / 100;
        mainHeight = cal / 1.77778;
        Margin = (EditorParent.current.offsetHeight - mainHeight) / 2;
      }
      sethiddenSide1({
        height: Margin,
      });
      setEditorStyle({
        width: cal,
        height: mainHeight,
        MainWidth: Mainwidth,
        HiddenDiv: (Mainwidth - cal) / 4,
        Margin: Margin,
        changed: true,
      });
      setMainDiv({
        width: cal,
        height: mainHeight,
        mainWidth: EditorParent.current.offsetWidth,
      });
      DataFromSlide(true, cal, mainHeight);
    } else if (CurrentProject.canvasSize == "9:16") {
      let mainHeight = EditorParent.current.offsetHeight - 20;
      let Mainwidth = EditorParent.current.offsetWidth;
      let cal = mainHeight * 0.5625;
      setEditorStyle({
        width: cal,
        height: mainHeight,
        MainWidth: Mainwidth,
        HiddenDiv: (Mainwidth - cal) / 4,
        changed: true,
      });
      
      setMainDiv({
        width: cal,
        height: mainHeight,
        mainWidth: EditorTrackerStart.current.offsetWidth,
      });
      //fixed this when different Ratio template was not loading
      DataFromSlide(true, cal, mainHeight);
    } else if (CurrentProject.canvasSize == "1:1") {
      let Height = EditorParent.current.offsetHeight - 20;
      let Mainwidth = EditorParent.current.offsetWidth;
        //fixed this when different Ratio template was not loading
      let cal = Height * 1.77778;
   
      let Margin = 10;
      setEditorStyle({
        width: Height,
        height: Height,
        MainWidth: Mainwidth,
        HiddenDiv: (Mainwidth - (Height + 1)) / 4,
        changed: true,
        Margin: Margin,
      });
      setMainDiv({
        width: Height,
        height: Height,
        mainWidth: Mainwidth,
        Margin: Margin,
      });
       //fixed this when different Ratio template was not loading
      DataFromSlide(true, Height, Height);
    }
  }, [CurrentProject.canvasSize, Call_CurrentProject]);

  useEffect(() => {
    if (EditorStyle != null && EditorStyle.changed) {
      zoomset(EditorZoom);
    }
  }, [EditorZoom]);

  const zoomset = (params) => {
    hideToolbarOnZoom();

    var width = (MainDiv.mainWidth * params) / 100;
    EditorParent.current.width = width + "px";

    let childWidth = (MainDiv.width * params) / 100;
    let parentWidth = (MainDiv.mainWidth * params) / 100;

    let newChildHeight = childWidth / (MainDiv.width / MainDiv.height);
    EditorTrackerStart.current.height = newChildHeight + "px";

    //fixed margin to zoom from center
    let Margin = 10;
    let HeightDiff = EditorParent.current.offsetHeight - newChildHeight;

    // let HeightDiff =
    //   EditorParent.current.offsetHeight -
    //   EditorTrackerStart.current.offsetHeight;

    if (HeightDiff > 0) {
      let requireMargin = HeightDiff / 2;
      Margin = requireMargin;
    }

    setEditorStyle({
      width: childWidth,
      height: (MainDiv.height * params) / 100,
      MainWidth: parentWidth,
      HiddenDiv: (EditorTrackerStart.current.offsetWidth - childWidth) / 4,
      Margin: Margin,
      changed: true,
    });
    sethiddenSide1({
      height: Margin,
    });
    //fixing scroll
  };

  // This handles Scrolling to center after zooming
  useEffect(() => {
    var width = (EditorParent.current.offsetWidth * EditorZoom) / 100;
    var differenceWidth = width - EditorParent.current.offsetWidth;
    var differenceHeight =
      EditorTrackerStart.current.offsetHeight -
      EditorParent.current.offsetHeight;

    EditorParent.current.scrollTo(differenceWidth / 2, differenceHeight / 2);
  }, [EditorStyle]);

  const StackStore = () => {
    return new Promise((resolve) => {
      var stack = [...UndoLayer];
      var PrevArray = clone(LayersData);

      if (stack.length < 10) {
        stack.push(PrevArray);
        setUndoLayer(stack);
        setRedoLayer([]);
      } else {
        stack.shift();
        stack.push(PrevArray);
        setUndoLayer(stack);
        setRedoLayer([]);
      }
      resolve();
    });
  };
  const hideToolbarOnZoom = (e) => {
    if (overlayHide !== true) {
      //alert("hide false-----")
      if (document.getElementsByClassName("TextFocus")[0]) {
        document
          .getElementsByClassName("TextFocus")[0]
          .classList.remove("TextFocus");
      }

      setcolorShow(false);
      setSliderShow(false);
      setoverlaydiv(false);
      setStrokeShow(false);
      setIsTTS(false);

      const array = Array.from(LayersData);
      let check = false;
      for (var i = 0; i < array.length; i++) {
        if (array[i].toolbar === true) {
          array[i].toolbar = false;
          check = true;
        }

        if (array[i].showDiv) {
          array[i].showDiv = false;
          check = true;
        }

        if (array[i].FurtherSetting === true) {
          array[i].FurtherSetting = false;
          check = true;
        }

        if (!array[i].DrapEndAnimatedText) {
          array[i].DrapEndAnimatedText = true;
          check = true;
        }

        if (array[i].Editable === true) {
          array[i].Editable = false;
          check = true;
        }
        if (array[i].type === "text") {
          array[i].edit = "false";
          check = true;
        }

        if ((array[i].isTTS = true)) {
          array[i].isTTS = false;
          check = true;
        }
      }
      if (check) {
        setLayersData(array);
      }
      if (MultiDrag.length != 0 && !DragProcess) {
        setMultiDrag([]);
      }
    }
    // else
    //     {

    //         const array = Array.from(LayersData)
    //         let check = false
    //         for (var i = 0; i < array.length; i++) {

    //             if (array[i].type === "text") {
    //                 array[i].edit = "false";
    //                 if (array[i].FurtherSetting === true) {
    //                     array[i].FurtherSetting = false;
    //                     check = true
    //                 }
    //                 if (array[i].Editable === true) {
    //                     array[i].Editable = false;
    //                     check = true
    //                 }
    //                 check = true
    //             }

    //         }
    //         if (check) {
    //             setLayersData(array);

    //         }
    //     }
  };

  const hideToolbar = (e) => {
    if (e.target && e.target.hasAttribute("editor_data")) {
      if (overlayHide !== true) {
        //alert("hide false-----")
        var textBlurFix = null;
        var tempElement = null;
        if (document.getElementsByClassName("TextFocus")[0]) {
          tempElement = document.getElementsByClassName("TextFocus")[0];
          textBlurFix = tempElement.querySelectorAll("span")[0];

          setisTextInputOrAreaFocus(false);
          document
            .getElementsByClassName("TextFocus")[0]
            .classList.remove("TextFocus");
        }

        setcolorShow(false);
        setSliderShow(false);
        setoverlaydiv(false);
        setStrokeShow(false);
        setIsTTS(false);
        //leftPanelHide
        seteditableObject({ showPanel: false, editableItem: [] });
        const array = Array.from(LayersData);
        let check = false;
        for (var i = 0; i < array.length; i++) {
          //text blur fix

          if (textBlurFix != null) {
            if (
              array[i].key === parseInt(textBlurFix.getAttribute("textkey"))
            ) {
              array[i].text = textBlurFix.innerHTML;
              array[i].originalText = textBlurFix.innerHTML;
              array[i].isFontButtonClick = true;
              array[i].height = tempElement.clientHeight;
              check = true;
            }
          }

          if (array[i].toolbar === true) {
            array[i].toolbar = false;
            check = true;
          }

          if (array[i].showDiv) {
            array[i].showDiv = false;
            check = true;
          }

          if (array[i].FurtherSetting === true) {
            array[i].FurtherSetting = false;
            check = true;
          }

          if (!array[i].DrapEndAnimatedText) {
            array[i].DrapEndAnimatedText = true;
            check = true;
          }

          if (array[i].Editable === true) {
            array[i].Editable = false;
            check = true;
          }
          if (array[i].type === "text") {
            array[i].edit = "false";
            check = true;
          }

          if ((array[i].isTTS = true)) {
            array[i].isTTS = false;
            check = true;
          }
        }
        if (check) {
          setLayersData(array);
        }
        if (MultiDrag.length != 0 && !DragProcess) {
          setMultiDrag([]);
        }
      }
    }
    // else
    //     {

    //         const array = Array.from(LayersData)
    //         let check = false
    //         for (var i = 0; i < array.length; i++) {

    //             if (array[i].type === "text") {
    //                 array[i].edit = "false";
    //                 if (array[i].FurtherSetting === true) {
    //                     array[i].FurtherSetting = false;
    //                     check = true
    //                 }
    //                 if (array[i].Editable === true) {
    //                     array[i].Editable = false;
    //                     check = true
    //                 }
    //                 check = true
    //             }

    //         }
    //         if (check) {
    //             setLayersData(array);

    //         }
    //     }
  };
  const hideToolbar2 = (e) => {
    if (e.target.className == "HiddenUpper") {
      if (overlayHide !== true) {
        var textBlurFix = null;
        if (document.getElementsByClassName("TextFocus")[0]) {
          var tempElement = document.getElementsByClassName("TextFocus")[0];
          textBlurFix = tempElement.querySelectorAll("span")[0];
          setisTextInputOrAreaFocus(false);
          document
            .getElementsByClassName("TextFocus")[0]
            .classList.remove("TextFocus");
        }
       

        setcolorShow(false);
        setSliderShow(false);
        setoverlaydiv(false);
        setStrokeShow(false);
        setIsTTS(false);

        //leftPanelHide
        seteditableObject({ showPanel: false, editableItem: [] });

        const array = Array.from(LayersData);
        let check = false;
        for (var i = 0; i < array.length; i++) {
          if (textBlurFix != null) {
            if (
              array[i].key === parseInt(textBlurFix.getAttribute("textkey"))
            ) {
              array[i].text = textBlurFix.innerHTML;
              array[i].originalText = textBlurFix.innerHTML;
              array[i].isFontButtonClick = true;
              check = true;
            }
          }

          if (array[i].toolbar === true) {
            array[i].toolbar = false;
            check = true;
          }
          if (array[i].FurtherSetting === true) {
            array[i].FurtherSetting = false;
            check = true;
          }
          if (array[i].Editable === true) {
            array[i].Editable = false;
            check = true;
          }
          if (array[i].type === "text") {
            array[i].edit = "false";
            check = true;
          }
          if (array[i].isTTS === true) {
            array[i].isTTS = false;
            check = true;
          }
          if (array[i].showDiv) {
            array[i].showDiv = false;
            check = true;
          }
          if (!array[i].DrapEndAnimatedText) {
            array[i].DrapEndAnimatedText = true;
            check = true;
          }
        }
        if (check) {
          setLayersData(array);
        }
        if (MultiDrag.length != 0 && !DragProcess) {
          setMultiDrag([]);
        }
      }
    }
  };

  useEffect(() => {
    setAtoZ([]);

    let data;
    if (Backgrounds.type === "color") {
      data = {
        background: Backgrounds.color,
      };
    } else if (Backgrounds.type === "gradient") {
      data = {
        background: Backgrounds.gradient.Gcolor,
      };
    } else if (Backgrounds.type === "image") {
      data = {
        backgroundImage: `url(${
          authenticationData.ApiBaseURL + "/" + Backgrounds.Path
        })`,
        backgroundSize: "cover",
        backgroundPosition: "center",
      };
    } else if (Backgrounds.type === "") {
      data = {
        background: "#ffffff",
      };
    }
    setStyle(data);
  }, [CanvasDisplay]);

  useEffect(() => {
    let data;

    // debugger
    if (Backgrounds.type != "") {
      if (Backgrounds.type === "color") {
        data = { background: Backgrounds.color };
      } else if (Backgrounds.type === "gradient") {
        data = {
          background: Backgrounds.gradient.Gcolor,
        };
      } else if (Backgrounds.type === "image") {
        if (
          !Backgrounds.Path.includes("data:image/png;base64") &&
          !Backgrounds.Path.includes("data:image/jpeg;base64")
        ) {
          data = {
            backgroundImage: `url(${
              authenticationData.ApiBaseURL + "/" + Backgrounds.Path
            })`,
            backgroundSize: "cover",
            backgroundPosition: "center",
          };
        } else {
          data = {
            backgroundImage: `url(${Backgrounds.Path})`,
            backgroundSize: "cover",
            backgroundPosition: "center",
          };
        }
      } else if (Backgrounds.type === "Animated") {
        //var adata = require(Backgrounds.AnimationPath);
        //import(""+Backgrounds.AnimationPath+"").then(setAnimatedBGData);
        setAnimatedBGData(
          authenticationData.ApiBaseURL + "/" + Backgrounds.AnimationPath
        );

        //}
      }

      // var Slider = Array.from(slides);
      // for (let i = 0; i < Slider.length; i++) {
      //     if (Slider[i].IsActive === true) {
      //         Slider[i].SlideBackground = Backgrounds;
      //         if (LayersData.length != 0) {
      //             Slider[i].LayerData = LayersData
      //         }
      //         break
      //     }
      // }

      // setTimeout(() => {
      //     setslides(Slider)
      // }, 7000);

      setStyle(data);
    } else {
      data = { background: "#ffffff" };

      setStyle(data);
    }
  }, [Backgrounds]);

  // Fits a slide's layers into a canvas of another size (video shape changed, or a slide made at
  // another editor size). Positions follow the canvas on each axis; sizes and text are scaled by the
  // same factor on both axes (the smaller one), so nothing is stretched and nothing grows past the
  // canvas. Before, sizes used the width factor only: going from 9:16 to 1:1 made every layer 1.8x
  // larger while the canvas height stayed the same (pictures 1080 px high on a 590 px canvas).
  // Layers at the left or top edge (x or y = 0) were also skipped.
  const convertLayer = (layer, width, height, Currwidth, Currheight) => {
    const array = Array.from(layer);
    if (height && width && Currwidth && Currheight) {
      const sx = Currwidth / width; // position factor, horizontal
      const sy = Currheight / height; // position factor, vertical
      const s = Math.min(sx, sy); // size factor
      const num = (v) => typeof v === "number" && isFinite(v);
      for (let i = 0; i < array.length; i++) {
        if (num(array[i].x) && num(array[i].y) && array[i].width && array[i].height) {
          array[i].x = array[i].x * sx;
          array[i].y = array[i].y * sy;
          array[i].width = array[i].width * s;
          array[i].height = array[i].height * s;
        }
        if (num(array[i].originalX)) array[i].originalX = array[i].originalX * sx;
        if (num(array[i].originalY)) array[i].originalY = array[i].originalY * sy;
        if (num(array[i].originalWidth)) array[i].originalWidth = array[i].originalWidth * s;
        if (num(array[i].originalHeight)) array[i].originalHeight = array[i].originalHeight * s;
        if (array[i].fontSize) array[i].fontSize = parseInt(array[i].fontSize * s);
        if (array[i].originalFontSize) array[i].originalFontSize = parseInt(array[i].originalFontSize * s);
        array[i].Editable = false;
        array[i].showDiv = false;
      }
    }
    return array;
  };

  const DataFromSlide = (params, Currwidth, Currheight) => {
    if (params) {
      let array = Array.from(slides);
      for (let i = 0; i < array.length; i++) {
        if (array[i].IsActive) {
          let width = calculateWidthByDuration(array[i].TotalLength);

          // setPrevious_TlTotalTime({
          //     time: Tl_TotalTime.time,
          //     width: Tl_TotalTime.width
          // })

          setTl_TotalTime({
            time: array[i].TotalLength,
            width: width,
          });
          if (array[i].LayerData.length !== 0) {
            let data = convertLayer(
              array[i].LayerData,
              array[i].canvasWidth,
              array[i].canvasHeight,
              Currwidth,
              Currheight
            );
            array[i].LayerData = data;
            setLayersData(data);
          } else {
            setLayersData([]);
          }
          array[i].canvasWidth = Currwidth;
          array[i].canvasHeight = Currheight;

          if (Backgrounds !== array[i].SlideBackground) {
            setBackgrounds(array[i].SlideBackground);
          }
        } else {
          let data = convertLayer(
            array[i].LayerData,
            array[i].canvasWidth,
            array[i].canvasHeight,
            Currwidth,
            Currheight
          );
          array[i].LayerData = data;
          array[i].canvasWidth = Currwidth;
          array[i].canvasHeight = Currheight;
        }
      }
      //alert("Setting Slide Data 2");
      setslides(array);
    } else {
      // debugger
      let array = Array.from(slides);
      for (let i = 0; i < array.length; i++) {
        if (array[i].IsActive === true) {
          let width = calculateWidthByDuration(array[i].TotalLength);

          // setPrevious_TlTotalTime({
          //     time: Tl_TotalTime.time,
          //     width: Tl_TotalTime.width
          // })

          setTl_TotalTime({ time: array[i].TotalLength, width: width });

          //doing this because Added Character true only show on canvas according to new login by @Ain
          array[i].LayerData.map((item) => {
            if (item.type === "Character") {
              item.Added = true;
            }
          });

          if (LayersData.length > 0) {
            array[i].LayerData = LayersData;
          } else if (array[i].LayerData.length !== 0) {
            array[i].LayerData.map((item) => {
              let oldWidthOnTimeline = item.widthOnTimeline;
              item.TimelineZoom = parseInt(timelineZoomVal); //now its is directly used from state in  the edtiortracker
              item.widthOnTimeline = calculateWidthByDuration(item.duration);
              item.startPositionOnTimeline = calculateWidthByDuration(
                item.startTime
              );
              item.startTransitionWidth =
                (item.startTransitionWidth / oldWidthOnTimeline) *
                item.widthOnTimeline;
              item.endTransitionWidth =
                (item.endTransitionWidth / oldWidthOnTimeline) *
                item.widthOnTimeline;
              item.midTransitionWidth =
                (item.midTransitionWidth / oldWidthOnTimeline) *
                item.widthOnTimeline;
            });

            setLayersData(array[i].LayerData);
          } else {
            setLayersData([]);
          }

          if (Backgrounds !== array[i].SlideBackground) {
            setBackgrounds(array[i].SlideBackground);
          }
          changeTimelineZoomVal(timelineZoomVal);
          break;
        }
      }
    }
  };

  useEffect(() => {
    if (EditorStyle) {
      DataFromSlide(false);
    }
  }, [slides]);

  useEffect(() => {
    console.log('12345', 12345)
    if (MultiDrag.length == 0) {
      const newArray = [...LayersData];
      let check = false;
      for (var i = 0; i < newArray.length; i++) {
        if (newArray[i].InMultiDrag) {
          newArray[i].InMultiDrag = false;
          check = true;
        }
      }
      if (check) {
        setLayersData(newArray);
      }
    }
    else{
      seteditableObject({ showPanel: false, editableItem: [] });
    }
  }, [MultiDrag]);

  useEffect(() => {
    if (AnimatedBGData) {
      const data = Lottie2.getRegisteredAnimations();

      const _Data = data.find((x) => x.name === Backgrounds.AnimationPath);

      //console.log(data);
      // for (let i = 0; i < data.length; i++) {
      //     if (data[i].name == value.AnimationId) {
      //         //Lottie.goto
      //     }
      // }
    }
  }, [AnimatedBGData, isPlayClicked]);

  const checkScale = () => {
    if (CurrentProject.canvasSize === "1:1") {
      return "1.8";
    } else if (CurrentProject.canvasSize === "9:16") {
      return "3.2";
    } else {
      return "1";
    }
  };

  const generateRulerY = () => {
    var divison = 20;
    var jsx = [];
    for (var i = 1; i <= divison; i++) {
      jsx.push(
        <span className="rulerScaleY">
          <span className="unitY"></span>
          <span>{i}</span>
        </span>
      );
    }
    return jsx;
  };

  const generateRulerX = () => {
    var divison = 14;
    var jsx = [];
    for (var i = 1; i <= divison; i++) {
      jsx.push(
        <span className="rulerScaleX">
          <span className="unitX"></span>
          <span className="ml-1">{i}</span>
        </span>
      );
    }
    return jsx;
  };
  const generateGridX = () => {
    var divison = 14;
    var jsx = [];
    for (var i = 1; i <= divison; i++) {
      jsx.push(
        <span className="GridX">
          <span className="gridLineX"></span>
        </span>
      );
    }
    return jsx;
  };
  const generateGridY = () => {
    var divison = 20;
    var jsx = [];
    for (var i = 1; i <= divison; i++) {
      jsx.push(
        <span className="GridY">
          <span className="gridLineY"></span>
        </span>
      );
    }
    return jsx;
  };

  // declare some global variables
  const [showSelection, setshowSelection] = useState(false);
  const [Xstart, setXstart] = useState(0);
  const [Ystart, setYstart] = useState(0);

  const test = (event) => {
    setshowSelection(true);
    // save the position where the mouse click started
    // Xstart = event.pageX;
    // Ystart = event.pageY;

    var boundsOfCanvas = document
      .getElementsByClassName("EditorTrackInner")[0]
      .getBoundingClientRect();
    setXstart(event.pageX - boundsOfCanvas.x);
    setYstart(event.pageY - boundsOfCanvas.y);

    var selectionDiv = document.createElement("div");
    selectionDiv.id = "selection";
    selectionDiv.opacity = 0;
    selectionDiv.style.left = Xstart + "px";
    selectionDiv.style.top = Ystart + "px";
    document
      .getElementsByClassName("EditorTrackInner")[0]
      .appendChild(selectionDiv);
  };

  const testMove = (event) => {
    var boundsOfCanvas = document
      .getElementsByClassName("EditorTrackInner")[0]
      .getBoundingClientRect();
    //console.log(showSelection);
    var selection = document.getElementById("selection");
    if (showSelection === true) {
      selection.opacity = 1;
      //console.log("x-boundx", event.pageX - boundsOfCanvas.x);
      //console.log("Xstart", Xstart);
      // horizontal selection
      if (event.pageX - boundsOfCanvas.x > Xstart) {
        // left to right
        selection.style.width = event.pageX - boundsOfCanvas.x - Xstart + "px";
      } else {
        // right to left
        //console.log("result", Xstart - (event.pageX - boundsOfCanvas.x));
        selection.style.left = event.pageX - boundsOfCanvas.x + "px";

        selection.style.width =
          Xstart - (event.pageX - boundsOfCanvas.x) + "px";
      }

      // vertical selection
      if (event.pageY - boundsOfCanvas.y > Ystart) {
        // top to bottom
        selection.style.height = event.pageY - boundsOfCanvas.y - Ystart + "px";
      } else {
        // bottom to top
        selection.style.top = event.pageY - boundsOfCanvas.y + "px";
        selection.style.height =
          Ystart - (event.pageY - boundsOfCanvas.y) + "px";
      }
    }
  };

  const testUp = (event) => {
    document.getElementById("selection").remove();
    setshowSelection(false);
    setXstart(0);
    setYstart(0);
  };

  return (
    <>
      {/* <div className="HiddenSidesUpper" style={hiddenSide1}></div>
      <div className="HiddenSidesLeft" style={hiddenSideLeft}></div> */}
      <div
        ref={EditorParent}
        id={"EditorParent"}
        className="EditorParent style-1"
      >
        <div
          //onMouseDown={(e) => test(e)}
          //onMouseMove={(e) => testMove(e)}
          //onMouseUp={(e) => testUp(e)}
          //onMouseLeave={(e) => testUp(e)}
          ref={EditorTrackerStart}
          className="EditorTrackerStart"
          style={{
            marginTop: EditorStyle != null ? EditorStyle.Margin : "",
            height: EditorStyle != null ? EditorStyle.height : "",
            width: EditorStyle != null ? EditorStyle.MainWidth : "",
          }}
        >
          <div
            className="HiddenUpper"
            onMouseDown={(e) => {
              hideToolbar2(e);
            }}
          >
            <div
              style={{
                width: EditorStyle != null ? EditorStyle.HiddenDiv : "",
              }}
              className="leftDarkHiddden"
            />
            <div
              style={{
                width: EditorStyle != null ? EditorStyle.HiddenDiv : "",
              }}
              className="leftLiteHiddden"
            />

            <div
              ref={EditorTrackInner}
              className="EditorTrackInner"
              style={{
                width: EditorStyle != null ? EditorStyle.width : "",
                height: EditorStyle != null ? EditorStyle.height : "",
                overflow: CanvasDisplay ? "" : "hidden",
              }}
            >
              {Backgrounds.type === "Animated" && (
                <Lottie
                  loop //= {isPlayClicked ? true : false}
                  path={AnimatedBGData}
                  play //= {isPlayClicked ? true : false}
                  style={{
                    width: "100%",
                    scale: checkScale(),
                    height: "100%",
                    position: "absolute",
                    zIndex: "-999px",
                  }}
                />
              )}

              {/* auto guides */}
              <div className="guideY_left" id="guideY_left"></div>
              <div className="guideY_right" id="guideY_right"></div>
              <div className="guideX_top" id="guideX_top"></div>
              <div className="guideX_bottom" id="guideX_bottom"></div>

              {/* ruler */}
              {enableRuler && (
                <>
                  <div className="rulerY">{generateRulerY()}</div>
                  <div className="rulerX">{generateRulerX()}</div>
                </>
              )}

              {/* grid */}
              {enableGrid && (
                <>
                  <div className="FullgridX">{generateGridX()}</div>
                  <div className="FullgridY">{generateGridY()}</div>
                </>
              )}

              {AtoZ.length != 0 && (
                <CanvasOverlay AtoZ={AtoZ} setAtoZ={setAtoZ} />
              )}

              {/* Move A → Z: path, end point, settings, and the movement while playing */}
              <MotionOverlay canvasRef={EditorTrackInner} />
              {/* Right-click on any layer: quick actions (move A → Z, settings, duplicate, order, lock, delete) */}
              <CanvasContextMenu canvasRef={EditorTrackInner} />
              {/* Lowers music while characters speak (when that option is on) */}
              <AudioDucker />

              <div
                editor_data="Data"
                className={"Editor"}
                tabIndex="0"
                style={Styled}
                onMouseDown={(e) => {
                  hideToolbar(e);
                }}
              >
                {LayersData.length != 0 &&
                  LayersData.map((value, index) => {
                    const zInd = index + 1;

                    if (value.optionPopUp) {
                      value.FurtherSetting = true;
                      value.optionPopUp = false;
                    }

                    // if(value.isTTS != undefined)
                    // {
                    //   if(value.isTTS)
                    //   {
                    //     if(!IsTTSShow)
                    //     {
                    //       setIsTTSShow(true)
                    //       setTTSData({
                    //         LayersData: LayersData,
                    //         setLayersData: setLayersData,
                    //         values: value,
                    //         setoverlaydiv: setoverlaydiv,
                    //         overlaydiv: overlaydiv,
                    //         overlayHide: overlayHide,
                    //         setoverlayHide: setoverlayHide,
                    //         parentWidth: EditorStyle.width,
                    //         parentHeight: EditorStyle.height,
                    //         EditorTrackInner: EditorTrackInner
                    //       })
                    //     }

                    //   }
                    //   else
                    //   {
                    //     if(IsTTSShow)
                    //     {
                    //       setIsTTSShow(false)
                    //       setTTSData(null)
                    //     }
                    //   }
                    // }

                    return (
                      <React.Fragment key={index}>
                        {value.Editable &&
                          CanvasDisplay &&
                          !value.lock &&
                          value.type !== "audio" &&
                          value.startPositionOnTimeline <= TickerPosition &&
                          value.startPositionOnTimeline +
                            value.widthOnTimeline >=
                            TickerPosition && (
                            <MyResize
                            
                              Editable={value.Editable}
                              index={index}
                              resizeRef={resizeRef}
                              resizeRef2={resizeRef2}
                              draggerRef={DraggerRef}
                              type={value.type}
                              values={value}
                              setIsTTS={setIsTTS}
                              LayersData={LayersData}
                              setLayersData={setLayersData}
                              MultiDrag={MultiDrag}
                              Call_ScreenShot={Call_ScreenShot}
                              setCall_ScreenShot={setCall_ScreenShot}
                            />
                          )}

                        {value.type === "Props" && (
                          <TrackerProps
                            resizeRef={resizeRef}
                            resizeRef2={resizeRef2}
                            value={value}
                            StackStore={StackStore}
                            TickerPosition={TickerPosition}
                            zInd={zInd}
                            index={index}
                            TickerStart={TickerStart}
                            setMultiDrag={setMultiDrag}
                            MultiDrag={MultiDrag}
                            Call_ScreenShot={Call_ScreenShot}
                            setCall_ScreenShot={setCall_ScreenShot}
                          />
                        )}

                        {value.type === "Shape" && (
                          <TrackerShapes
                            resizeRef={resizeRef}
                            resizeRef2={resizeRef2}
                            value={value}
                            TickerStart={TickerStart}
                            setMultiDrag={setMultiDrag}
                            MultiDrag={MultiDrag}
                            StackStore={StackStore}
                            TickerPosition={TickerPosition}
                            zInd={zInd}
                            index={index}
                            Call_ScreenShot={Call_ScreenShot}
                            setCall_ScreenShot={setCall_ScreenShot}
                          />
                        )}

                        {value.type === "Video" && (
                          <TrackerVideo
                            resizeRef={resizeRef}
                            resizeRef2={resizeRef2}
                            value={value}
                            StackStore={StackStore}
                            TickerPosition={TickerPosition}
                            zInd={zInd}
                            TickerStart={TickerStart}
                            index={index}
                            setMultiDrag={setMultiDrag}
                            MultiDrag={MultiDrag}
                            Call_ScreenShot={Call_ScreenShot}
                            setCall_ScreenShot={setCall_ScreenShot}
                          />
                        )}

                        {value.type === "image" && (
                          <TrackerImages
                            resizeRef={resizeRef}
                            resizeRef2={resizeRef2}
                            setAtoZ={setAtoZ}
                            value={value}
                            StackStore={StackStore}
                            TickerPosition={TickerPosition}
                            zInd={zInd}
                            index={index}
                            TickerStart={TickerStart}
                            setMultiDrag={setMultiDrag}
                            MultiDrag={MultiDrag}
                            Call_ScreenShot={Call_ScreenShot}
                            setCall_ScreenShot={setCall_ScreenShot}
                          />
                        )}
                        {value.type === "audio" && (
                          <SoundPlay
                            value={value}
                            TickerPosition={TickerPosition}
                            isPlayClicked={isPlayClicked}
                            key={value.key}
                            SoundRef={SoundRef}
                            Call_ScreenShot={Call_ScreenShot}
                            setCall_ScreenShot={setCall_ScreenShot}
                            ComingFrom={"EditorTracker"}
                          />
                        )}

                        {value.type === "text" && (
                          <TrackerText
                            resizeRef={resizeRef}
                            resizeRef2={resizeRef2}
                            value={value}
                            StackStore={StackStore}
                            TickerPosition={TickerPosition}
                            zInd={zInd}
                            index={index}
                            inputRef={inputRef}
                            setMultiDrag={setMultiDrag}
                            MultiDrag={MultiDrag}
                            TickerStart={TickerStart}
                            Call_ScreenShot={Call_ScreenShot}
                            setCall_ScreenShot={setCall_ScreenShot}
                          />
                        )}

                        {value.type === "basicShape" && (
                          <ChangeableShapes
                            AciveShapeColor={AciveShapeColor}
                            setAciveShapeColor={setAciveShapeColor}
                            resizeRef={resizeRef}
                            resizeRef2={resizeRef2}
                            value={value}
                            StackStore={StackStore}
                            TickerPosition={TickerPosition}
                            zInd={zInd}
                            index={index}
                            TickerStart={TickerStart}
                            setMultiDrag={setMultiDrag}
                            MultiDrag={MultiDrag}
                            Call_ScreenShot={Call_ScreenShot}
                            setCall_ScreenShot={setCall_ScreenShot}
                          />
                        )}

                        {value.type === "Character" && value.opc === 1 && (
                          <TrackerCharacter
                            draggerRef={DraggerRef}
                            isTTS={isTTS}
                            isStanding={isStanding}
                            setIsStanding={setIsStanding}
                            resizeRef={resizeRef}
                            resizeRef2={resizeRef2}
                            setAtoZ={setAtoZ}
                            key={index}
                            value={value}
                            StackStore={StackStore}
                            TickerPosition={TickerPosition}
                            zInd={zInd}
                            index={index}
                            TickerStart={TickerStart}
                            setMultiDrag={setMultiDrag}
                            MultiDrag={MultiDrag}
                            Call_ScreenShot={Call_ScreenShot}
                            setCall_ScreenShot={setCall_ScreenShot}
                          />
                        )}

                        {value.type === "AnimatedText" && value.opc === 1 && (
                          <AnimatedText
                            draggerRef={DraggerRef}
                            isTTS={isTTS}
                            isStanding={isStanding}
                            setIsStanding={setIsStanding}
                            resizeRef={resizeRef}
                            resizeRef2={resizeRef2}
                            setAtoZ={setAtoZ}
                            key={index}
                            value={value}
                            StackStore={StackStore}
                            TickerPosition={TickerPosition}
                            zInd={zInd}
                            index={index}
                            TickerStart={TickerStart}
                            setMultiDrag={setMultiDrag}
                            MultiDrag={MultiDrag}
                            Call_ScreenShot={Call_ScreenShot}
                            setCall_ScreenShot={setCall_ScreenShot}
                          />
                        )}

                        {CanvasDisplay &&
                          value.Subtype !== "AnimatedBackground" &&
                          value.startPositionOnTimeline <= TickerPosition &&
                          value.startPositionOnTimeline +
                            value.widthOnTimeline >=
                            TickerPosition && (
                            <>
                              {value.toolbar === true && !value.lock && (
                                <Toolbar
                                  isTTS={isTTS}
                                  setIsTTS={setIsTTS}
                                  isStanding={isStanding}
                                  setIsStanding={setIsStanding}
                                  keys={index}
                                  values={value}
                                  type={value.type}
                                  parentWidth={EditorStyle.width}
                                  parentHeight={EditorStyle.height}
                                />
                              )}

                              {value.FurtherSetting === true && !value.lock && (
                                <FurtherSetting
                                  keys={value.key.toString()}
                                  setSliderShow={setSliderShow}
                                  SliderShow={SliderShow}
                                  type={value.type}
                                  setoverlaydiv={setoverlaydiv}
                                  overlaydiv={overlaydiv}
                                  overlayHide={overlayHide}
                                  setoverlayHide={setoverlayHide}
                                  values={value}
                                  colorShow={colorShow}
                                  setcolorShow={setcolorShow}
                                  StrokeShow={StrokeShow}
                                  setStrokeShow={setStrokeShow}
                                  FontShow={FontShow}
                                  setFontShow={setFontShow}
                                  setAtoZ={setAtoZ}
                                  parentWidth={EditorStyle.width}
                                  parentHeight={EditorStyle.height}
                                  EditorTrackInner={EditorTrackInner}
                                  AciveShapeColor={AciveShapeColor}
                                  setAciveShapeColor={setAciveShapeColor}
                                  setLayersData={setLayersData}
                                  LayersData={LayersData}
                                />
                              )}

                              {value.isTTS != undefined &&
                                value.isTTS == true && (
                                  <TTSSettings
                                    LayersData={LayersData}
                                    setLayersData={setLayersData}
                                    values={value}
                                    setoverlaydiv={setoverlaydiv}
                                    overlaydiv={overlaydiv}
                                    overlayHide={overlayHide}
                                    setoverlayHide={setoverlayHide}
                                    parentWidth={EditorStyle.width}
                                    parentHeight={EditorStyle.height}
                                    EditorTrackInner={EditorTrackInner}
                                  />
                                )}
                            </>
                          )}
                      </React.Fragment>
                    );
                  })}
                <div
                  style={{
                    position: "absolute",
                    left: "50%",
                    top: "50%",
                    transform: "translate(-50%, -50%)",
                    zIndex: "100",
                  }}
                >
                  {" "}
                  <Loading loading={context.isLoading} />
                </div>
              </div>
              {MultiDrag.length > 1 && (
                <MultiDragging
                  Data={MultiDrag}
                  setDragProcess={setDragProcess}
                  DragProcess={DragProcess}
                />
              )}
            </div>
            {/* <div className="Editor" tabIndex='0'>
                        <canvas ref={AnimationRef} width="1004" height="564" onDragOver={allowDrop} style={{ display: CanvasDisplay  ? 'none' : 'inline-block', width: '100%', height: '100%' }} />
                    </div> */}

            <div
              style={{
                width: EditorStyle != null ? EditorStyle.HiddenDiv : "",
              }}
              className="rightLiteHiddden"
            ></div>
            <div
              style={{
                width: EditorStyle != null ? EditorStyle.HiddenDiv : "",
              }}
              className="rightDarkHiddden"
            ></div>
          </div>
        </div>
      </div>
    </>
  );
};
export default EditorTracker;
